// src/pages/ContactUs.js
import React, { useState } from 'react';
import './ContactUs.css';

function ContactUs() {
  // State for contact form
  const [formResponse, setFormResponse] = useState('');
  const [contactFormData, setContactFormData] = useState({
    name: '',
    email: '',
    phone: '',
    smsConsent: false,
    message: ''
  });

  // Handle changes in the contact form fields
  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Submit the contact form
  const handleContactSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('name', contactFormData.name);
    data.append('email', contactFormData.email);
    data.append('phone', contactFormData.phone);
    data.append('smsConsent', contactFormData.smsConsent);
    data.append('message', contactFormData.message);

    fetch('php/mail.php', {
      method: 'POST',
      body: data,
    })
      .then((response) => response.text())
      .then((responseText) => {
        setFormResponse(responseText);
        // Reset form
        setContactFormData({
          name: '',
          email: '',
          phone: '',
          smsConsent: false,
          message: '',
        });
      })
      .catch(() => {
        setFormResponse('There was an error sending your message. Please try again.');
      });
  };

  return (
    <div className="contact-page">
      <main className="main-content">
        <h1>Contact Us</h1>
        <div className="company-info">
          <p><strong>Law Office of Edgar Lopez APC</strong></p>

          <p>
            <strong>Address:</strong> 18 East State St. Ste. 203-2, Redlands, CA 92373
          </p>

          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+19517492948">(951) 749-2948</a>
          </p>

          <p>
            <strong>Fax:</strong> Not Available
          </p>

          <div
            className="quick-actions"
            style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "8px" }}
          >
            <a
              className="qa-btn"
              href="tel:+19517492948"
              aria-label="Call Edgar Lopez Law"
            >
              Call
            </a>

            <a
              className="qa-btn secondary"
              href="https://maps.google.com/?q=18%20East%20State%20St%20Ste.%20203-2%2C%20Redlands%2C%20CA%2092373"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get directions to 18 East State St. Ste. 203-2, Redlands, CA 92373"
            >
              Get Directions
            </a>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleContactSubmit}>
          <label htmlFor="name">Your Name</label>
          <input
            id="name"
            name="name"
            placeholder="Your Name"
            required
            value={contactFormData.name}
            onChange={handleContactChange}
          />

          <label htmlFor="email">Your Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="Your Email"
            required
            value={contactFormData.email}
            onChange={handleContactChange}
          />

          <label htmlFor="phone">Phone Number</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            placeholder="Your Phone Number"
            required
            value={contactFormData.phone}
            onChange={handleContactChange}
            inputMode="tel"
          />

          <div className="checkbox-group">
            <input
              id="smsConsent"
              name="smsConsent"
              type="checkbox"
              checked={contactFormData.smsConsent}
              onChange={handleContactChange}
            />
            <label htmlFor="smsConsent" className="checkbox-label">
              By checking this box, you agree to receive SMS messages from the Law Office of Edgar Lopez APC related to your request. You can respond <strong>STOP</strong> to stop receiving messages at any time or <strong>HELP</strong> for help. Message and data rates may apply. Message frequency varies. See our{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" className="footer-link">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer" className="footer-link">
                Terms and Conditions
              </a>.
            </label>
          </div>

          <label htmlFor="message">Your Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Write your message here..."
            rows="5"
            required
            value={contactFormData.message}
            onChange={handleContactChange}
            aria-label="Your Message"
          ></textarea>

          <button type="submit" className="send-btn">
            Send Message
          </button>
        </form>

        {formResponse && <div className="form-response">{formResponse}</div>}
      </main>
    </div>
  );
}

export default ContactUs;